import React from "react";
import { Alert as AlertAntd, Tag, Typography } from "antd";
import { TrapStatusData } from "../../types";
import ArchiveBoxIcon from "@heroicons/react/24/outline/ArchiveBoxIcon";
import { formatDate } from "../../utils/helpers";
import { DEVICE_STATUS_LABELS, deviceStatusTag } from "../../utils/deviceState";

const { Text } = Typography;

type Props = {
  item: TrapStatusData;
  onClick?: (id: string) => void;
};

const AlertDialog: React.FC<Props> = ({ item, onClick }) => {
  const tag = deviceStatusTag(item);
  // needs_attention predates the shadow state and only a status can carry it.
  const label =
    !item?.state && item?.status === "needs_attention"
      ? "Needs Attention"
      : DEVICE_STATUS_LABELS[tag];
  // With a state, the tag shows it, so the date is when it was set.
  const asOf =
    item?.state && item?.state_updated_at
      ? item.state_updated_at
      : item?.status_updated_at;

  return (
    <div key={item?._id} className="alert-dialog-container">
      <AlertAntd
        onClick={() => onClick && onClick(item?._id)}
        message={
          // Only the first line shares its row with the tag, so the lines under
          // it keep the card's full width however wide the tag is.
          <div className="trap-status-card">
            {item?.org_name && (
              <Text type="secondary" className="trap-status-card-line">
                {item.org_name}
              </Text>
            )}
            <Text className="trap-status-card-line font-bold">
              {item?.trapsite_name} - {item?.name}
            </Text>
            <Text className="trap-status-card-line">{item?.gps}</Text>
            <Text className="trap-status-card-line">
              As of{" "}
              {formatDate(new Date(asOf), {
                dateOnly: true,
              })}
            </Text>
            <Tag className={`status-tag ${tag}`}>{label}</Tag>
          </div>
        }
        className={`trap-status-dialog trap-status-dialog--${item?.status === "needs_attention" ? "error" : "primary"}`}
        showIcon
        icon={
          <ArchiveBoxIcon
            className="w-6 h-6 mt-1"
            style={{ color: "#0c4a6e" }}
          />
        }
      />
    </div>
  );
};

export default AlertDialog;
